import { PureComponent } from 'react';

import Icon from 'components/Icon';
import { InputHasIcon } from 'components/Input/InputVariants';

import DropdownList from './components';
import { isEnter } from './constants';

class DropdownInput extends PureComponent {
  static defaultProps = {
    options: [],
  };

  state = {
    isOptionsShown: false,
    isFocused: false,
  };

  componentDidUpdate(prevProps) {
    const { options } = this.props;

    if (!options.length) {
      return this.toggleShowOptions(false);
    }

    if (options !== prevProps.options && this.state.isFocused) {
      this.toggleShowOptions(true);
    }
  }

  toggleShowOptions = bool =>
    this.state.isOptionsShown !== bool &&
    this.setState({ isOptionsShown: bool });

  handleEnterPress = e => {
    if (isEnter(e)) {
      this.props.onEnterKeyPress();
    }
  };

  handleChange = ({ value }) => {
    const { onChange } = this.props;

    !this.state.isFocused && this.setState({ isFocused: true });
    onChange(value);
  };

  handleBlur = () => {
    this.setState({ isFocused: false });
    this.toggleShowOptions(false);
  };

  handleFocus = () => {
    const { options } = this.props;

    this.setState({ isFocused: true });

    if (!options.length) {
      return;
    }

    this.toggleShowOptions(true);
  };

  handleClearButtonClick = () => {
    this.props.onInputClear();
  };

  render() {
    const {
      placeholder,
      className,
      options,
      value = '',
      onOptionClick,
    } = this.props;

    const { isOptionsShown } = this.state;

    return (
      <div
        className={cx('search', { 'is-opened': isOptionsShown })}
        onBlur={this.handleBlur}
        onKeyDown={this.handleEnterPress}
      >
        <label>
          <InputHasIcon
            iconClassName={cx('search__icon', {
              spinner: this.props.loading,
            })}
            icon="help-search"
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            placeholder={placeholder}
            className={className}
            value={value}
          />
        </label>
        <button
          className={cx('search__btn-close', {
            'search__btn-close_visible': value.length,
          })}
          onClick={this.handleClearButtonClick}
        >
          <Icon className="search__icon-close" icon="close-14" />
        </button>
        <DropdownList
          test={isOptionsShown}
          options={options}
          onOptionClick={onOptionClick}
          closeList={this.handleBlur}
        />
      </div>
    );
  }
}

export default DropdownInput;
